import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'formatAddress'
})
export class FormatAddressPipe implements PipeTransform {
  transform(location: any): string {
    if (!location) return '';

    return [
      location.addressLine1,
      location.addressLine2,
      location.city?.cityName,
      location.state?.stateName,
      location.postal_code
    ].filter(Boolean).join(', ');
  }
}
